import { createProject, editProject, getProjects } from "@/Api";
import { useEffect, useState } from "react";
import { Button, Field, Header, Icon, Input, Message, Modal, Table, Toast } from "react-frontier";
import { Dropdown } from "semantic-ui-react";
import Validator from "@/Validator";
import { useNavigate } from "react-router-dom";
import type { Project } from "Classes";

enum MODALS{
   CREATED=1
}

const INITVALUE:Project={
   project_id: 0,
   project_name: '',
   status: 0,
   user_created: '',
   system_key: ''
}

var ListProjects=()=>{
   var navigate=useNavigate();
   var[error,setError]=useState<string>(null);
   var[modal,setModal]=useState<number>(null);
   var[isEdit,setIsEdit]=useState<boolean>(false);
   var[projects,setProjects]=useState<Project[]>(null);
   var[project,setProject]=useState<Project>(INITVALUE);
   var[modalPrompts,setModalPrompts]=useState<string[]>(null);

   var onOpenModal=(project?: Project)=>{
      if(project){
         setProject({
            status: project.status,
            project_id: project.project_id,
            project_name: project.project_name,
            user_created: project.user_created,
            system_key: project.system_key
         })
         setIsEdit(true);
      }
      setModal(MODALS.CREATED);
   }

   var onCloseModal=()=>{
      setModal(null);
      setIsEdit(false);
      setModalPrompts(null);
      setProject(INITVALUE);
   };

   var get=()=>{
      getProjects().then(res=>{
         if(res.error)return setError(res.message);

         setProjects(res.data);
      }).catch(()=>{
         return setError('Ocurrio un error al consultar la informacion. (DCPJ-G-1)');
      });
   };

   useEffect(()=>{
      get();
   },[]);

   var onCreateProject=(setLoading: (loading: boolean) => void)=>{
      setLoading(true);

      var{valid,prompts}=Validator(project,{
         project_name: [{ rule: 'empty', label: 'Nombre del proyecto' }] 
      });
      if(!valid)return setModalPrompts(prompts);

      createProject(project.project_name, project.system_key).then(res=>{
         if(res.error)return setModalPrompts([res.message]);

         onCloseModal();
         navigate(`/project/${res.data.project_id}`)

         Toast.success('Proyecto creado correctamente.');

      }).catch(()=>{
         setModalPrompts(['Ocurrio un error creando el proyecto. (DCPJ-CRT-1)']);
      }).finally(()=>{
         setLoading(false);
      });
   };

   var onEditProject=(setLoading: (loading: boolean) => void)=>{
      setLoading(true);

      var{valid,prompts}=Validator(project,{
         status: [{rule: 'number', label: 'Estatus'}],
         project_name: [{rule: 'empty', label: 'Nombre del proyecto'}]
      });
      if(!valid)return setModalPrompts(prompts);

      editProject(project.project_name,project.status,project.project_id, project.system_key).then(res=>{
         if(res.error)return setModalPrompts([res.message]);

         get();
         onCloseModal();
         Toast.success('Proyecto actualizado correctamente.');

         setModal(null);
      }).catch(()=>{
         setModalPrompts(['Ocurrio un error crear. (PDV-U-1)']);
      }).finally(()=>{
         setLoading(false);
      });
   };

   if(error)return <Header text={error} />;

   return <div style={{ padding: '60px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
      {/* ==========
         HEADER
      ============*/}
      <Header text={'AREMA DOCUMENTACION'} subtext={'Gestiona tus proyectos de documentacion'} />


      {/* ==========
         BODY
      ============*/}
      <Table
         fitted
         striped
         selectable
         title='Proyectos'
         centeredIndexes={[4]}
         style={{ width: '800px' }}
         collapsingIndexes={[0,3,4]}
         headers={['ID','Proyecto','Creador','Estatus',<Icon name='wrench' />]}
         button={<Button color="black" iconName="plus" text="Agregar" onClick={()=>onOpenModal()} />}  
      >
         {!projects?(
            <Table.Row>
               <Table.Cell className='empty' colSpan={4}><Header loading /></Table.Cell>
            </Table.Row>
         ):projects.length>0?projects.map((p)=>(
            <Table.Row
               key={p.project_id} 
               onClick={() => navigate(`/project/${p.project_id}`)}
               style={{ cursor: 'pointer' }}
               data={[
                  p.project_id,
                  p.project_name,
                  p.user_created,
                  <span style={{
                     color: 'white',
                     fontSize: '12px',
                     padding: '4px 5px',
                     lineHeight: '12px',
                     borderRadius: '100px',
                     backgroundColor: p.status === 2 ? '#ffa600ff' : '#21ba45'
                  }}>
                     {p.status === 2 ? 'Archivado' : 'Activo'}
                  </span>,
                  <div onClick={(e) => { e.stopPropagation(); }} onMouseDown={(e) => e.stopPropagation()}>
                     <Dropdown icon={(
                        <div className='fr label' style={{ padding: '3px 10px' }}>
                           <Icon name='ellipsis-h' style={{ margin: 0 }} />
                        </div>
                     )}>
                        <Dropdown.Menu>
                           <Dropdown.Item onClick={(e)=>{ e.stopPropagation(); onOpenModal(p); }}>
                              <Icon name="edit" style={{ marginRight: 3 }} /> Editar
                           </Dropdown.Item>
                        </Dropdown.Menu>
                     </Dropdown>
                  </div>   
               ]} />
         )):(
         <Table.Row>
            <Table.Cell className='empty' colSpan={4}>No se encontraron proyectos</Table.Cell>
         </Table.Row>
         )}
      </Table>
      
      {/* ==========
         MODALS
      ============*/}
      <Modal open={MODALS.CREATED===modal} size='tiny' onClose={onCloseModal}>
         <Modal.Header>{isEdit ? 'Editar' : 'Crear Nuevo'} Proyecto</Modal.Header>
         <Modal.Content>
            <Input 
               label='Nombre del proyecto' 
               value={project.project_name} 
               onChange={(val) => setProject({ ...project, project_name: val })} />
            <Field label='Identificador del sistema'>
               <Dropdown
                  selection
                  placeholder='Selecciona un sistema'
                  value={project.system_key || ''}
                  onChange={(_, { value }) => setProject({ ...project, system_key: value as string })}
                  options={[
                     { value: 'ADMIN', text: 'ADMIN' },
                     { value: 'OPERATIONS', text: 'OPERATIONS' },
                     { value: 'PDV', text: 'PDV' },
                     { value: 'REPORTS', text: 'REPORTS' },
                     { value: 'SCANNER', text: 'SCANNER' },
                  ]}
               />
            </Field>
            {isEdit&&(
               <Field label='Estatus'>
                  <Dropdown
                     selection 
                     placeholder='Estatus'
                     value={project.status} 
                     onChange={(_, { value })=>setProject({ ...project, status: +value })}
                     options={[
                        { value: 1, text: 'Activo' },
                        { value: 2, text: 'Archivado' }
                     ]} 
                  />
               </Field>
            )}
            <Message type='error' list={modalPrompts} />
         </Modal.Content>
         <Modal.Actions>
            <Button text='Guardar' color='black' onClick={isEdit ? onEditProject : onCreateProject} />
            <Button text='Cerrar' onClick={onCloseModal} />
         </Modal.Actions>
      </Modal>
   </div>;
};

export default ListProjects;